// services/ReviewFolder/index.js
const { DEV, VITE_LOCAL } = import.meta.env

import { reviewService as local } from './review.service.local'
import { reviewService as remote } from './review.service.remote'

function getEmptyReview() {
  return {
    userId: '',         // ייקבע בעת יצירת הביקורת (מהמשתמש המחובר)
    animeId: '',        // מזהה האנימה
    recommended: null,  // האם ממליץ (true/false)
    rating: null,       // ציון בין 1 ל-10
    content: '',        // טקסט ביקורת אופציונלי
    likes: 0,           // מספר הלייקים (מתחילים מ-0)
    likedBy: [],        // רשימת מזהי משתמשים שביצעו לייק
    reports: [],        // מערך דיווחים (לדוגמה: { userId, reason })
    hidden: false,      // אם הביקורת מוסתרת (אם מתקבלים 2 דיווחים לפחות)
    createdAt: null,
    updatedAt: null,
  }
}

const service = VITE_LOCAL === 'true' ? local : remote


export const reviewService = { ...service, getEmptyReview }

if (DEV) window.reviewService = reviewService
